
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import ModalMixin from "./mixin";
import LoadHeader from "@/components/barcodeSystem/load/LoadHeader.vue";
import LoadOrderTable from "@/components/barcodeSystem/load/LoadOrderTable.vue";
import { LoadResource } from "@/models/api/barcodeSystem/loads/get";
import notifications from "@/lib/notifications";

const loadModuleState = getModule(LoadModule);

@Component({
  name: modals.loadViewModal,
  components: {
    LoadHeader,
    LoadOrderTable
  }
})
export default class LoadViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  isUnlocking: boolean = false;

  async load() {
    this.loadingComplete = false;
    this.show();
    try {
      await loadModuleState.loadLoad(this.selectedItem.id);
      await loadModuleState.loadLoadOrders(this.selectedItem.id);
    } catch (ex) {
      notifications.error("Failed to load receiving load", "Failed to load receiving load.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  get orderCount() : number
  {
    if(loadModuleState.currentLoadOrders)
      return loadModuleState.currentLoadOrders.length;
    return 0
  }

  get currentLoad() : LoadResource
  {
    return loadModuleState.currentLoad;
  }

  async unlockLoad(){
    if(this.currentLoad)
    {
      this.isUnlocking = true;
      try {
        await loadModuleState.unlockLoad(this.currentLoad);
        notifications.success("Load Unlocked", "Load successfully unlocked.");
        await this.reloadLoad();
      } catch (error) {
        notifications.error(
          "Load Unlock Failed",
          error.response.data.message
        );
      }   
      finally{
        this.isUnlocking = false;
      }
    }
  }

  async reloadLoad(){
    this.loadingComplete = false;
    try{
      await loadModuleState.reloadLoad();
      await loadModuleState.loadLoadOrders(this.currentLoad.id);} 
    catch (ex) {
      notifications.error("Failed to load receiving load", "Failed to load receiving load.", ex);
    }
    this.loadingComplete = true;
  }

  reset() {
    this.loadingComplete = false;
  }
}
